import React from "react"
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { H1 } from "../../../designSystem/typography/Heading";
import { Divider } from "../../../designSystem/Divider";
import { PageSection } from "../../../designSystem/PageSection";
import { PageSectionVariant } from "../../../designSystem/PageSectionDefs";
import styled from "styled-components";


export const PageSectionOverview = (): JSX.Element => 
{
    const variants:PageSectionVariant[] = ['default', 'dark', 'dark-card', 'default-no-card'];
    const title = 'Default title';
    const subTitle = 'Default subtitle';

    return (
    
        <div>
            <H1>PageSections</H1>

            <Flex flexDirection="column" gap={24} style={{padding:'20px'}}>

                {variants.map((variant, index) => (
                    <React.Fragment key={variant}>

                    {index > 0 && <Divider />}

                    <PageSection styleVariant={variant} >
                        <Container>
                            <div>variant: {variant}</div>
                            <div>header:none</div>
                        </Container>
                    </PageSection>

                    <PageSection
                        header={{
                            title: variant + ' title',
                            icon: 'calendar',
                            avatar: { text: 'AB' },
                            subTitle: { text: subTitle, icon: 'clock', iconColor: '#f00' },
                        }}
                        styleVariant={variant}>
                        
                        <Container>
                            <div>variant: {variant}</div>
                            <div>header-icon</div>
                            <div>header-avatar-text</div>
                            <div>header-subtitle</div>
                            <div>header-subtitle-icon</div>
                            <div>header-subtitle-iconColor</div>
                        </Container>
                    </PageSection>

                    <PageSection
                        header={{
                            title: variant + ' title',
                            icon: 'calendar',
                            avatar: { text: 'AB' },
                            subTitle: { text: 'Subtitle', icon: 'clock', iconColor: '#f00' },
                            button: { variant:'filled', text: 'Click me', onClick: () => alert('Button clicked') }
                        }}
                        styleVariant={variant}>
                        <Container>
                            <div>variant: {variant}</div>
                            <div>header-icon</div>
                            <div>header-avatar-text</div>
                            <div>header-subtitle</div>
                            <div>header-subtitle-icon</div>
                            <div>header-subtitle-iconColor</div>
                            <div>header-button</div>
                        </Container>
                    </PageSection>

                    <PageSection
                        header={{
                            title: variant + ' title',
                            icon: 'calendar',
                            avatar: { text: 'AB' },
                            subTitle: { text: 'Subtitle', icon: 'clock', iconColor: '#f00' },
                            button: { variant:'filled', text: 'Click me', onClick: () => alert('Button clicked') },
                            defaultCollapsed: true
                        }}
                        styleVariant={variant}>
                        <Container>
                            <div>variant: {variant}</div>
                            <div>header-icon</div>
                            <div>header-avatar-text</div>
                            <div>header-subtitle</div>
                            <div>header-subtitle-icon</div>
                            <div>header-subtitle-iconColor</div>
                            <div>header-button</div>
                            <div>header-defaultCollapsed:true</div>
                        </Container>
                    </PageSection>

                    <PageSection
                        header={{
                            title: variant + ' title',
                            icon: 'calendar',
                            avatar: { text: 'AB' },
                            subTitle: { text: 'Subtitle', icon: 'clock', iconColor: '#f00' },
                            popupMenuButton: { 
                                buttonVariant:'text-white',
                                entries:[
                                    { type: 'menuItem', text: 'Menu item 1', onClick: () => alert('Menu item 1 clicked') },
                                    { type: 'menuItem', text: 'Menu item 2', onClick: () => alert('Menu item 2 clicked') },
                                ]
                            },
                            defaultCollapsed: true
                        }}
                        styleVariant={variant}>
                        <Container>
                            <div>variant: {variant}</div>
                            <div>header-icon</div>
                            <div>header-avatar-text</div>
                            <div>header-subtitle</div>
                            <div>header-subtitle-icon</div>
                            <div>header-subtitle-iconColor</div>
                            <div>header-popupMenuButton</div>
                            <div>header-defaultCollapsed:true</div>
                        </Container>
                    </PageSection>
                
                    </React.Fragment>
                ))}
                    
            </Flex>
        </div>
    );
}

const Container = styled.div`
    padding: 16px;
`;